import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {AuthProvider} from './context/AuthProvider';
import { BrowserRouter as Router , Route , Routes } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
          <Routes>
            <Route path='/*' element={<App/>}/>
          </Routes>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

